module.exports = {
  originalState: { api: 'originalState', human: 'Originalzustand' },
  tuned: { api: 'tuned', human: 'Baulich verändert (getunt)' },
  plannedTuning: { api: 'plannedTuning', human: 'Bauliche Veränderung geplant' }
}
